import { PATHS } from '@/infrastructure/utils/route-constants';

export default function redirectHome({ next, router, to, store }) {
  if (
    PATHS.login.pathBase.includes(to.path) &&
    store.getters['login/isAuthenticated']
  ) {
    return router.push({ name: 'DashboardPage' });
  }
  return next();
}
